/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const DismissFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Dismiss filled"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#666"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.923-13.923a.833.833 0 0 1 0 1.179L13.178 12l2.745 2.744a.833.833 0 0 1-1.179 1.179L12 13.178l-2.744 2.745a.833.833 0 0 1-1.179-1.179L10.822 12 8.076 9.256a.833.833 0 1 1 1.179-1.179L12 10.822l2.744-2.745a.833.833 0 0 1 1.179 0"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const DismissFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'dismiss-filled-icon'}
      icon={DismissFilled}
      {...props}
      size={size}
    />
  );
};
